import {
  createWakeLoopApiClient,
  type WakeLoopApiClientFoundation,
} from "@wakeloop/api-client";
import { buildWakeLoopRequestContextHeaders } from "@wakeloop/gateway-contract";
import { buildRequestAuthHeaders } from "../config/request-headers";
import { fetchSpaceRequestWithTimeout } from "./fetch-with-timeout";

export function createCliApiClientFoundation(
  baseUrl: string
): WakeLoopApiClientFoundation {
  return createWakeLoopApiClient({
    baseUrl,
    transport: async (request) =>
      await fetchSpaceRequestWithTimeout({
        url: request.url,
        operation: request.operation,
        init: request.init,
        timeoutMs: request.timeoutMs,
      }),
    getAuthHeaders: async ({ requestUrl }) =>
      await buildRequestAuthHeaders({
        requestUrl,
      }),
    getRequestContextHeaders: async ({ requestContext, spacePassword }) =>
      buildWakeLoopRequestContextHeaders({
        requestContext,
        ...(spacePassword === undefined ? {} : { spacePassword }),
      }),
  });
}
